<template>
    <div>
        
        <el-checkbox-group v-model="array" @change="handleChecked">
            <el-checkbox v-for="c in checkboxes" :label="c.value" :key="c.value">{{c.label}}</el-checkbox>
        </el-checkbox-group>
    </div>
</template>
<script>
const Regions={78:'СПб',47:'ЛО',10:'Карелия',60:'Псков',53:'В.Новгород',23:'Краснодар',35:'Вологда'};
const Deal = {'SELL':'продать','RENT':'сдать'};
const Types={'FLAT':'квартиру','HOUSE':'дом','LAND':'участок','BUSINESS':'бизнес','WAREHOUSE':'Склад','GARAGE':'гараж','PAKRING_LOT':'м/место','COMM_LAND':'Комм. землю'};
const checkboxes=[];
for(let r in Regions){
    for(let d in Deal){
        for(let t in Types){
            checkboxes.push({
                value:r+':'+d+':'+t,
                label: Regions[r]+' '+Deal[d]+' '+Types[t]
            })
        }
    }
}
import { CheckboxGroup, Checkbox } from 'element-ui';
export default {
  name: 'ReMarketingExport',
  components: {
    [Checkbox.name]: Checkbox, 
    [CheckboxGroup.name]: CheckboxGroup,
  },
  props: {
    value: {
      type: String,
      required: true
    }
  },
  data() {
    return {
        checkboxes
    };
  },
  computed: {
    // Split the string into an array
    array: {
      get() {
        return this.value.split(',').map(item => item.trim());
      },
      // When the array changes, update the value
      set(newValue) {
        this.$emit('input', newValue.join(',').trim());
      }
    },
    // Join the array back into a string for display
    joinedString() {
      return this.array.join(', ').trim();
    }
  },
  watch: {
    array: {
      handler(newArray) {
        // Emit the joined string when the array changes
        this.$emit('change', newArray.join(',').trim());
      },
      deep: true
    }
  },
  methods: {
    handleClick(c){
        // console.log(c);
    },
    handleChecked(event){
        // console.log(event, this.array);
    },  
    handleInput(event) {
      const newValue = event.target.value;
      const parsedArray = newValue.split(',').map(item => item.trim());

      // Update the array via the computed property's setter
      this.array = parsedArray;
    }
  },
  mounted() {
  }
};
</script>
